/**
 * Two-step sign-in (#92): who in an organisation has to use it.
 *
 * Cognito does the second step itself — an authenticator app's code — and
 * the pool offers it to everybody. Not a code by email: Cognito refuses it
 * while email is also how a password is reset, as whoever had the inbox
 * would then hold both factors (sst.config.ts). What the pool cannot
 * do is require it of some people and not others, so that is decided here,
 * per organisation, by its owner, and enforced by the API: somebody who must
 * and has not set it up can reach their own account and nothing else.
 *
 * A tablet unlocked with a PIN is not a password sign-in and is not asked.
 */
export const MFA_RULES = ["off", "admins", "everyone"];
/**
 * Off until an owner turns it on: switching it on for everybody at once, on
 * a deploy, would send every owner to a setup screen they did not ask for.
 */
export const DEFAULT_MFA_RULE = "off";
export function isMfaRule(value) {
    return typeof value === "string" && MFA_RULES.includes(value);
}
/** The stored rule, or the default for an organisation that never chose. */
export function settledMfaRule(value) {
    return isMfaRule(value) ? value : DEFAULT_MFA_RULE;
}
/** Whether this rule asks it of somebody with this organisation role. */
export function mfaRequiredFor(rule, orgRole) {
    if (rule === "everyone")
        return true;
    if (rule === "admins")
        return orgRole === "owner" || orgRole === "admin";
    return false;
}
/** Sent with a 403 that is about two-step sign-in, so the app can offer setup. */
export const MFA_SETUP_HEADER = "x-baros-mfa-setup";
/** How the 403 reads, and how the app recognises one without the header. */
export const MFA_SETUP_PREFIX = "Two-step sign-in needed:";
//# sourceMappingURL=mfa.js.map